/**
 * Created by mark on 08/02/2018.
 */

import React  from 'react';
import {ListGroupItem , ListGroup} from 'react-bootstrap';
import Translation from '../store/internationalization-store.js'
import homeworkStore from '../store/homework-store';
import Summary from '../components/wizards/assignments/assignment_summary.js'
export default class TaskNames extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        homeworkStore.currentHomeworkTasks = this.props.tasks
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.selectionIndex = 0;
        this.setState({
            update:this
        });
        homeworkStore.currentHomeworkTasks = this.props.tasks
    }


    getTypeTranslation(type){

        switch(type)
        {
            case "reading" : return Translation.get('119' , '');
            case "listening" : return Translation.get('117' , '');
            case "speaking" : return Translation.get('118' , '');
            case "writing" : return Translation.get('120' , '');
            case "verbs" : return null;
            case "sentence" : return null;
            case "exam" : return null;
        }

        return false;
    }

    returnString() {

        if(!this.props.tasks) return null;
        
        var oldmsg = 0;
        var completeMsg = "";

        for(var idx = 0 ; idx < this.props.tasks.length; idx++){

            var msg = "";

            for(var key in this.props.tasks[idx])
            {
                switch(key)
                {
                    case "skill":
                    case "type":
                        var type = this.getTypeTranslation(this.props.tasks[idx][key]);

                        if(!type)
                        {
                            break;
                        }
                        else
                        {
                            msg += type;

                            if(this.props.notList) break;
                            if(this.props.tasks[idx][key] != "verbs" || this.props.tasks[idx][key] != "sentence") msg += " | ";

                        }

                        break;
                    case "verb_name" :
                        if (this.props.tasks[idx][key] != undefined && this.props.tasks[idx][key] != "undefined") {
                            msg += this.props.tasks[idx][key] +' | ';
                        }
                        break;
                    case "translation" :

                        msg += (Translation.get(''+this.props.tasks[idx][key] , "") + " | ");
                        break;
                    case "title" :
                        msg += (Translation.get(''+this.props.tasks[idx][key] , ""));
                        break;
                    case "module_translation" :
                        msg += (" | " + Translation.getModuleNoIndexTranslation(''+this.props.tasks[idx][key] , "") );
                        break;

                    case "module_translations":

                        var keys = this.props.tasks[idx][key];

                        for(var jdx = 0; jdx < keys.length; jdx++)
                        {
                                msg += (" | " + Translation.getModuleNoIndexTranslation(''+this.props.tasks[idx][key] , "") );
                        }

                        break;
                }



                if(oldmsg < msg.length)
                {
                    msg += " ";
                }

                oldmsg = msg.length;

            }

            completeMsg += msg;

        }
        return completeMsg;
    }

    render(){

        if(!this.props.tasks) return null;
        var types = [];
        var tasks = [];
        var vocabList = [];
        var sentenceList = [];
        var grammarList = [];
        var verbList = [];
        var examList = [];
        var oldmsg = 0;

        for(var idx = 0 ; idx < homeworkStore.currentHomeworkTasks.length; idx++){
            var task = homeworkStore.currentHomeworkTasks[idx];
            if (task.type == "vocab") {
                vocabList.push(Translation.getModuleNoIndexTranslation(task['module_translations'][0]));
                homeworkStore.currentHomeworkTasks[idx].title = 
                        Translation.getModuleNoIndexTranslation(task['module_translations'][0]) + " | " 
                        + Translation.get(task['translation']);
            }

            if (task.type == "sentence") {
                sentenceList.push(Translation.getModuleNoIndexTranslation(task['module_translations'][0]));
                homeworkStore.currentHomeworkTasks[idx].title = 
                        Translation.getModuleNoIndexTranslation(task['module_translations'][0])
            }

            if (task.type == "grammar") {
                grammarList.push(Translation.getModuleNoIndexTranslation(task['module_translations'][0]));
                homeworkStore.currentHomeworkTasks[idx].title = 
                        Translation.getModuleNoIndexTranslation(task['module_translations'][0])
            }

            if (task.type == "verb") {
                verbList.push(Translation.getModuleNoIndexTranslation(task['verb_name']));
                homeworkStore.currentHomeworkTasks[idx].title = 
                        Translation.getModuleNoIndexTranslation(task['verb_name'])
            }

            if (task.type == "exam") {
                examList.push(Translation.getModuleNoIndexTranslation(task['module_translation']));
                homeworkStore.currentHomeworkTasks[idx].title = 
                        Translation.getModuleNoIndexTranslation(task['module_translation'])
            }

        }


        if (vocabList.length > 0) {
            types.push("vocab");
        }
        if (sentenceList.length > 0) {
            types.push("sentence");
        }
        if (grammarList.length > 0) {
            types.push("grammar");
        }
        if (examList.length > 0) {
            types.push("exam");
        }
        if (verbList.length > 0) {
            types.push("verb");
        }


        if(this.props.isListGroup)
        {
            return <Summary types={types}/>;
        }

        return <span className="custom-counter">{tasks}</span>

    }

}